import app from 'firebase/app';
import 'firebase/analytics';

import '@capacitor-community/firebase-analytics';
import { isPlatform } from '@ionic/react';
import { IONICWrapper } from './common';
import { store } from '../store';
import { FETCH_VALUE, KEYS } from './constants';
import { USER_ROLE } from './constants.analytics';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Device } from '@capacitor/device';
import { dayjs } from './Date/DateUtil';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseAnalyticsConfig = KEYS.FIRBASE_ANALYTICS_CONFIG;

let analyticsWeb: app.analytics.Analytics;
export const initFirebaseWeb = () => {
  app.initializeApp(firebaseAnalyticsConfig);
  analyticsWeb = app.analytics();

}
/**
 *
 * LogEvent Method used to log events
 *
 * @param name
 * @param parameters
 * @param sessionFields
 */
export const logEvent = (
  name: string,
  parameters: object,
  sessionFields: string[] = []
) => {
  if (name) {
    const storeData = store.getState();
    const session = getSessionStoreData(storeData);
    const fetchValue: any = (key: string) =>
      IONICWrapper.details.auth && IONICWrapper.details.auth.user[key];
    const authProviderObjectId = fetchValue(FETCH_VALUE.SUB);
    const carrierId = fetchValue(FETCH_VALUE.CARRIERID);
    const roles = fetchValue(FETCH_VALUE.ROLES);
    const utmSource = fetchValue(FETCH_VALUE.UTM_SOURCE);
    const utmMedium = fetchValue(FETCH_VALUE.UTM_MEDIUM);
    const utmCampaign = fetchValue(FETCH_VALUE.UTM_CAMPAIGN);
    let params: any = parameters;
    params = {
      ...params,
      ...(typeof authProviderObjectId !== 'undefined' ? { authProviderObjectId } : {}),
      ...(typeof carrierId !== 'undefined' ? { carrierId } : {}),
      ...(typeof roles !== 'undefined' ? { roles: roles.toString() } : {}),
      ...(typeof utmSource !== 'undefined' ? { utmSource } : {}),
      ...(typeof utmMedium !== 'undefined' ? { utmMedium } : {}),
      ...(typeof utmCampaign !== 'undefined' ? { utmCampaign } : {})
    };

    //Role based Cohorts Firebase Analytics implementation 
    fireBaseImplementation(roles);

    if (session) {
      params = { ...params, sessionId: getSessionId(session.uuid || '') };
      /**
       *  Session Fields Array includes required fields  from session
       */
      sessionFields.forEach(field => {
        params[field] = session[field] || '';
      });
    }
    if (isPlatformCheck()) {
      analyticsWeb.logEvent(name, params);
    } else {
      FirebaseAnalytics.logEvent({ name, params });
    }
  }
};

/**
 *  SetUserId Method used to set the unique userid
 */
export const setUserId = (userId: string) => {
  if (userId) {
    if (isPlatform('desktop') || isPlatform('mobileweb')) {
      analyticsWeb.setUserId(userId);
    } else {
      FirebaseAnalytics.setUserId({ userId });
    }
  }
};

/**
 *  SetUserProperty Method used to set the user properties
 */
export const setUserProperty = (name: string, value: string) => {

  if (name && value) {
    if (isPlatform('desktop') || isPlatform('mobileweb')) {
      analyticsWeb.setUserProperties({ name, value });
    } else {
      FirebaseAnalytics.setUserProperty({ name, value });
    }
  }
};

/**
 *  SetScreenName Method used to log screen navigationss
 */
export const setScreenName = (screenName: string) => {

  if (screenName) {
    if (isPlatform('desktop') || isPlatform('mobileweb')) {
      analyticsWeb.setCurrentScreen(screenName);
    } else {
      FirebaseAnalytics.setScreenName({ screenName });
    }
  }
};

export const getSessionId = (id: string): string => {
  return id + dayjs(new Date()).format('MMDDYYYYHHmmss');
};

export const fetchCurrentTime = (): string => {
  const month = new Date().getMonth() + 1;
  const date = new Date().getDate();
  const year = new Date().getFullYear();
  const hour = new Date().getHours();
  const minute = new Date().getMinutes();
  const seconds = new Date().getSeconds();
  const monthStr = month / 10 < 1 ? `0${month.toString()}` : month.toString();
  const dateStr = date / 10 < 1 ? `0${date.toString()}` : date.toString();
  const yearStr = (year % 100).toString();
  const hourStr = hour / 10 < 1 ? `0${hour.toString()}` : hour.toString();
  const minuteStr = minute / 10 < 1 ? `0${minute.toString()}` : minute.toString();
  const secondsStr = seconds / 10 < 1 ? `0${seconds.toString()}` : seconds.toString();
  return monthStr + dateStr + yearStr + hourStr + minuteStr + secondsStr;
};

export const getApplicationInfo = async () => {
  const info = await Device.getInfo();
  let channel = null;
  if (info.platform === 'web') {
    channel = 'web-app';
  } else if (info.platform === 'android' || info.platform === 'ios') {
    channel = 'mobile-app';
  }
  const timeString = fetchCurrentTime();
  const uuidLastFour = (await Device.getId()).identifier;
  const user = (IONICWrapper.details.auth && IONICWrapper.details.auth.user) || null;
  return {
    os: info.operatingSystem,
    device_name: info.model,
    model: info.model,
    channel,
    uuid: uuidLastFour.substring(uuidLastFour.length - 4),
    sessionId: uuidLastFour.substring(uuidLastFour.length - 4) + timeString,
    userId: (user && user.upn) || '',
    roles: (user && user.roles && user.roles.join(',')) || ''
  };
};

export const getApplicationInfoBeforeLogin = async () => {
  const info = await Device.getInfo();
  let channel = null;
  if (info.platform === 'web') {
    channel = 'web-app';
  } else if (info.platform === 'android' || info.platform === 'ios') {
    channel = 'mobile-app';
  }
  return {
    os: info.operatingSystem,
    device_name: info.model,
    model: info.model,
    channel
  };
};
const isPlatformCheck=()=> {
  return isPlatform('desktop') || isPlatform('mobileweb');
}

const getSessionStoreData=(storeData: any) =>{
  return storeData && storeData.App && storeData.App.session;
}

function fireBaseImplementation(roles: any) {
  if (typeof roles !== "undefined") {
    if (isPlatform('desktop') || isPlatform('mobileweb')) {
      analyticsWeb.setUserProperties({
        User_Role: roles.toString().replace(/carrier/g, ''),
      });

    } else {
      FirebaseAnalytics.setUserProperty({
        name: USER_ROLE,
        value: roles.toString().replace(/carrier/g, ''),
      });
    }
  }
}


